import { QueryParameterSchema } from '../../context/QueryParameterContext';

export const sortableFields = [
  'sourceCourseName',
  '-sourceCourseName',
  'equivalentCourseName',
  '-equivalentCourseName',
  'sourceEducationLevelName',
  '-sourceEducationLevelName',
  'countryCode',
  '-countryCode',
  'id',
  '-id',
];
type SortableFields = (typeof sortableFields)[number];

export const sortParameter: QueryParameterSchema<'sort'> = {
  getDefaultValue: ({ defaultParameters }) => defaultParameters.sort,
  getValue: ({ parameters }) => parameters.sort,

  fromUrlSearchParams: ({ urlSearchParams, defaultValue }) => ({
    sort: (urlSearchParams.get('sort') as SortableFields) || defaultValue,
  }),
  toUrlSearchParams: ({ value }) => ({ sort: value }),
  toSearchQuery: ({ value }) => {
    if (!value) return {};
    return { sort: value as SortableFields };
  },
  sanitize: ({ value, defaultValue }) => {
    if (!value) return { sort: defaultValue };
    const fields = value.split(',');
    const validFields = fields.filter((field) => sortableFields.includes(field as SortableFields));
    if (validFields.length === 0) return { sort: defaultValue };
    return { sort: validFields.join(',') };
  },
};
